/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IOnlyCSearchResultContainer containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum expandRefinersCount {
    all = 'all',
    one = 'one',
    two = 'two',
    three = 'three',
    four = 'four'
}

export interface IOnlyCSearchResultContainerConfig extends Msdyn365.IModuleConfig {
    itemsPerPage?: number;
    variantsToShow?: number;
    allowBackNavigation?: boolean;
    imageSettings?: Msdyn365.IImageSettings;
    expandRefinersCount?: expandRefinersCount;
    disableHierarchy?: boolean;
    includeAttributes?: boolean;
    enableAffiliationBasedPricing?: boolean;
    updateRefinerPanel?: boolean;
    className?: string;
    clientRender?: boolean;
    maxSizeDisplay?: number;
    wishListLink?: IWishListLinkData;
    favouritesHeading?: string;
    favouritesContent?: string;
    sizesHeading?: string;
    campaignItems?: ICampaignItemsData[];
    hideCategory?: number;
}

export interface IOnlyCSearchResultContainerResources {
    noResultsForRefinersText: string;
    resultCategoryNotFoundText: string;
    resultSearchNotFoundText: string;
    paginationAriaLabel: string;
    priceFree: string;
    priceRangeSeparator: string;
    originalPriceText: string;
    currentPriceText: string;
    ratingAriaLabel: string;
    flipperNext: string;
    flipperPrevious: string;
    searchTextPrefix: string;
    numberOfProducts: string;
    oneProduct: string;
    categoryLinkAriaLabel: string;
    sortByDropdownLabel: string;
    sortByOptionNameAsc: string;
    sortByOptionNameDesc: string;
    sortByOptionPriceAsc: string;
    sortByOptionPriceDesc: string;
    sortByOptionRatingDesc: string;
    sortByOptionBestSelling: string;
    sortByOptionNewScore: string;
    sortByOptionTrendingScore: string;
    sortByOptionRelevanceDesc: string;
    placeholderTextMax: string;
    minLabel: string;
    maxLabel: string;
    rangeNameFormat: string;
    validationErrorNotNumber: string;
    validationErrorNotRange: string;
    clearAllText: string;
    choiceSummaryLabel: string;
    choiceFormat: string;
    choiceRangeValueFormat: string;
    choiceAriaLabel: string;
    closeAriaLabel: string;
    modalTitle: string;
    modalCloseButtonText: string;
    minValueSliderThumbAriaLabel: string;
    maxValueSliderThumbAriaLabel: string;
    featureSimilarLooksTitle: string;
    featureSimilarDescriptionTitle: string;
    productCountAriaLabel: string;
    singleProductCountAriaLabel: string;
    swatchItemAriaLabel: string;
    refineItemsAriaLabel: string;
    refineItemAriaLabel: string;
    backtoCategories: string;
    lifeTag: string;
    newArrivalTag: string;
    productsNotFound: string;
    newArrivalMsg: string;
    productLifeTag: string;
    splitSizeText: string;
    colorText: string;
    showAllText: string;
    showLessText: string;
}

export interface IWishListLinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export const enum CampaignItemsCampaignTextWidthAlignment {
    Verticalcenter = 'Verticalcenter',
    Verticalleft = 'Verticalleft',
    Verticalright = 'Verticalright'
}

export const enum CampaignItemsCampaignTextHeightAlignment {
    Horizontalcenter = 'Horizontalcenter',
    Horizontaltop = 'Horizontaltop',
    Horizontalbottom = 'Horizontalbottom'
}

export interface ICampaignItemsData {
    campaignTitle?: ICampaignTitleData;
    campaignIndex?: number;
    campaignImage?: Msdyn365.IImageData;
    campaignText?: string;
    campaignTextWidthAlignment?: CampaignItemsCampaignTextWidthAlignment;
    campaignTextHeightAlignment?: CampaignItemsCampaignTextHeightAlignment;
    campaignLink?: ICampaignLinkData;
}

export const enum CampaignTitleTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface ICampaignTitleData {
    text: string;
    tag?: CampaignTitleTag;
}

export interface ICampaignLinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IOnlyCSearchResultContainerProps<T> extends Msdyn365.IModule<T> {
    resources: IOnlyCSearchResultContainerResources;
    config: IOnlyCSearchResultContainerConfig;
    slots: {
        quickview: React.ReactNode[];
    };
}
